import { render } from "./ImagePreview.vue?vue&type=template&id=01435496&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"

import "./ImagePreview.vue?vue&type=style&index=0&id=01435496&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01435496"]])

export default __exports__